import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { group } from 'src/app/shared/utils';
import { DatasetChangesKind } from './dataset-editor-dialog.component';

@Component({
  templateUrl: 'change-dataset.dialog.html',
  styleUrls: ['change-dataset.dialog.scss'],
  standalone: false
})
export class VisualEditorChangeDatasetDialog {
  datasetChangeType = DatasetChangesKind;

  constructor(
    public dialogRef: MatDialogRef<VisualEditorChangeDatasetDialog>,
    @Inject(MAT_DIALOG_DATA) public data: VisualEditorChangeDatasetDialogData) {
  }

  close(result: boolean): void {
    this.dialogRef.close(result);
  }
}

export interface VisualEditorChangeDatasetDialogData {
  kind: DatasetChangesKind;
}

interface AffectedDataset {
  index: number,
  fieldNames: string[]
}
